import { Component, OnInit, Input } from '@angular/core'

import { AuthService } from '../../auth/auth.service'
import { UserService } from '../shared/user.service'
import { User } from '../shared/user.model'

@Component({
  selector: 'cm-nearest-user-list',
  templateUrl: './nearest-user-list.component.html',
  styleUrls: ['./nearest-user-list.component.css']
})
export class NearestUserListComponent implements OnInit {

  @Input() userOrigin: string

  public users: User[]

  constructor(private authService: AuthService,
    private userService: UserService) { }

  ngOnInit() {
    // this.userService.getNearestUsers(this.userOrigin)
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/users/nearest-user-list/nearest-user-list.component.ts